export const NewFeatureIds = {
  // NOTE: Examples of usage
  IMAGES: 'new_images_section',
  EXPLORE_NEWS_09_07_2025: 'explore_news_09_07_2025',
  // POST_CIENTIFICO: 'new_post_cientifico_feature',
} as const

export type NewFeatureId = (typeof NewFeatureIds)[keyof typeof NewFeatureIds]

export const getSeenFlag = (featureId: NewFeatureId): string =>
  `seen_${featureId}`

export interface NewFeatureConfig {
  id: NewFeatureId
  introducedDate: string
  uiTargets: string[]
  dismissesOnVisit?: string
}

export const newFeatures: Record<NewFeatureId, NewFeatureConfig> = {
  // NOTE: Examples of usage
  [NewFeatureIds.IMAGES]: {
    id: NewFeatureIds.IMAGES,
    introducedDate: '2025-05-06T08:45:53.148Z',
    uiTargets: ['sidebar.image'],
    dismissesOnVisit: 'sidebar.image',
  },
  [NewFeatureIds.EXPLORE_NEWS_09_07_2025]: {
    id: NewFeatureIds.EXPLORE_NEWS_09_07_2025,
    introducedDate: '2025-07-09T00:00:00.000Z',
    uiTargets: ['sidebar.explore'],
    dismissesOnVisit: 'sidebar.explore',
  },
  // [NewFeatureIds.POST_CIENTIFICO]: {
  //   id: NewFeatureIds.POST_CIENTIFICO,
  //   introducedDate: new Date().toISOString(),
  //   uiTargets: ['sidebar.useCases', 'useCases.tool.post-cientifico'],
  //   dismissesOnVisit: 'toolDetail.post-cientifico',
  // },
}
